import injected from "./injected";
import walletconnect from "./walletconnect";
import walletlink from "./walletlink";
import portis from "./portis";
import fortmatic from "./fortmatic";
import torus from "./torus";
import squarelink from "./squarelink";
import arkane from "./arkane";
import authereum from "./authereum";

export default {
  injected,
  walletconnect,
  walletlink,
  portis,
  torus,
  fortmatic,
  squarelink,
  arkane,
  authereum
};
